import type { IconSvgObject } from './types';

const LeftToRightListDashIcon: IconSvgObject = [
  ["path", { d: "M9 5L21 5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 5L5 5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 12L21 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 12L5 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M9 19L21 19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M3 19L5 19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }]
];

export default LeftToRightListDashIcon;
